import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Icon } from './index';
var SkholeIcon21 = Icon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  enableBackground: "new 0 0 40 40",
  version: "1.1",
  viewBox: "0 0 40 40",
  xmlSpace: "preserve"
}, void 0, /*#__PURE__*/_jsx("path", {
  d: "M35.5 20.4c0 1-.6 1.9-1.4 2.4L8.7 36.9c-.4.2-.9.4-1.4.4-.5 0-1-.1-1.4-.4-.9-.5-1.4-1.4-1.4-2.4v-29c0-1 .5-1.9 1.4-2.4.9-.5 1.9-.5 2.8 0L34.1 18c.9.5 1.4 1.4 1.4 2.4",
  className: "st21"
})));
export default SkholeIcon21;